import React from 'react';
import Landing_Section_2 from '../../images/shopify-popup/landing-section-2.png'

class SectionTwo extends React.Component {
  render() {
    return (
      <div className="main-container">
        <section className="switchable feature-large">
          <div className="container">
            <div className="row justify-content-around">
              <div className="col-md-6">
                <img src={Landing_Section_2} alt="Image" />
              </div>
              <div className="col-md-6 col-lg-5">
                <div className="switchable__text">
                  <h2>Conversion-ready Shopify popups with over 70 templates</h2>
                  <p className="lead">
                  Get your visitors' attention with gamification and exit-intent popups! Pop a gamification or exit-intent popup to the visitors who are about to leave their carts with products in them.
                   Increase engagement while reducing cart abandonment.
                  </p>
                  <a
                    id="landing--try-variant-page-builder-now--section2-link"
                    href="https://dashboard.popupfox.com/register"
                    target="_blank"
                  >
                    Try Variant Page Builder Now ↗
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <div className="feature feature-2 boxed boxed--border box-maxhight-div">
                  <i className="icon icon-Approved-Window font-icon-bolder"></i>
                  <div className="feature__body">
                    <p>
                    Design and embed your popup, which is fully 
                    compatible with Shopify, with Popupfox's popup creator in minutes.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="feature feature-2 boxed boxed--border box-maxhight-div">
                  <i className="icon icon-Support font-icon-bolder"></i>
                  <div className="feature__body">
                    <p>
                    Benefit from 24/7 customer support. Send all your inquiries to Popupfox 
                    via live chat or email and find a solution to your issues immediately.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="feature feature-2 boxed boxed--border box-maxhight-div">
                  <i className="icon icon-Like font-icon-bolder"></i>
                  <div className="feature__body">
                    <p>
                     Popupfox offers 100% customer satisfaction. If you're not satisfied with Popupfox’s Shopify popup creator,
                     you can get a refund within 30 days.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default SectionTwo;